import { GtmTrackingType } from '../constants';
import TrackingHelperInstance from './gtmTrackingHelper';

class GtmTransactionDelegator {
	constructor() {
		this.type = GtmTrackingType.PURCHASE;
		this.dataMapper = [
			{
				useDataValueFrom: 'skuID',
				gtmKey: 'id',
			},
			{
				useDataValueFrom: 'skuQty',
				gtmKey: 'quantity',
			},
			{
				useDataValueFrom: 'skuTitle',
				gtmKey: 'name',
			},
			{
				useDataValueFrom: 'skuPriceexVAT',
				gtmKey: 'price',
			},
			{
				useDataValueFrom: 'skuHierarchy',
				gtmKey: 'category',
			},
			{
				useDataValueFrom: 'skuItemCategory',
				gtmKey: 'item_category',
			},
			{
				useDataValueFrom: 'skuItemCategory2',
				gtmKey: 'item_category2',
			},
			{
				useDataValueFrom: 'skuItemCategory3',
				gtmKey: 'item_category3',
			},
			{
				useDataValueFrom: '',
				gtmKey: 'brand',
			},
			{
				useDataValueFrom: '',
				gtmKey: 'variant',
			},
			{
				useDataValueFrom: 'pricingType',
				gtmKey: 'dimension19',
			},
		];
	}

	getTrackingData() {
		const orderInfo = window.dataLayer[0].order;

		if (
			document.querySelector(`[data-gtm-tracking-type="gtm_purchase"]`) &&
			window.dataLayer[0].order &&
			window.dataLayer[0].navigation &&
			window.od.Cookie.get('PurchaseOrderID') !== orderInfo.orderid
		) {
			return {
				event: 'purchase',
				ecommerce: {
					currencyCode: window.dataLayer[0].navigation.currencyISO,
					purchase: {
						actionField: {
							id: orderInfo.orderid,
							revenue: orderInfo.subTotal,
							tax: orderInfo.totalVAT,
							shipping: orderInfo.deliveryValue,
							coupon: orderInfo.voucherCode || '',
						},
						products: this.generateProducts(),
					},
				},
				eventCallback: this.setOrderIdCookie.bind(this),
			};
		}
	}

	setOrderIdCookie() {
		const orderID = window.dataLayer[0].order.orderid;
		window.od.Cookie.set('PurchaseOrderID', orderID);
	}

	generateProducts() {
		return window.dataLayer[0].order.products.map((item, index) => {
			return TrackingHelperInstance.mapDataViaGtmKey(
				item,
				this.dataMapper,
				true,
				index + 1,
			);
		});
	}
}

const GtmTransactionDelegatorInstance = new GtmTransactionDelegator();
export default GtmTransactionDelegatorInstance;

// for test purpose only
export const GtmTransactionDelegatorClass = GtmTransactionDelegator;
